
import {BrowserRouter as Router, Routes, Route} from "react-router-dom"
import About from "./screens/About";
import Project from "./screens/Project";
import HomePage from "./screens/HomePage";
import Write from "./screens/Write";
import CV from "./screens/CV";
function App() {
  return (
    <Router>
      <div>
        <Routes>
          <Route path='/' element={<HomePage/> } exact></Route>
          <Route path='/about' element={<About/> }></Route>
          <Route path='/projects' element={<Project/> }></Route>
          <Route path='/writes' element={<Write></Write> }></Route>
          <Route path='/resume' element={<CV></CV> }></Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;
